module.exports = __webpack_public_path__ + "static/e-commerce-continuously-thriving-90239a3b674b756b323f95d9bb86c9af.png";